import { TypeFare, TypeFlight } from "@/lib/redux/features/flight/type"
import { isGalileoSystem } from "@/utils/flight/isGalileoSystem"

// VN quốc tế trả nhiều chặng (đi/về) trong cùng 1 fare nên được hiển thị & đặt như combo khứ hồi, giống Galileo
export const isVnComboFare = (system?: string | null, legCount = 1) =>
  system === "VN" && legCount > 1

export const isComboFare = (system?: string | null, legCount = 1) =>
  isGalileoSystem(system) || isVnComboFare(system, legCount)

type FareEntry = {
  flight?: Pick<TypeFlight, "fareDataId"> & { fareData?: TypeFare | null } | null
}

const sameVnFare = (left: FareEntry, right: FareEntry) => {
  const leftFlight = left.flight
  const rightFlight = right.flight
  const leftFare = leftFlight?.fareData
  const rightFare = rightFlight?.fareData

  if (leftFare?.system !== "VN" || rightFare?.system !== "VN") return false

  // `fareDataId` is the normal booking reference. The other fields cover
  // restored/verified booking data where that reference or the assigned index
  // may not be present.
  if (
    leftFlight?.fareDataId != null &&
    rightFlight?.fareDataId != null &&
    leftFlight.fareDataId === rightFlight.fareDataId
  ) {
    return true
  }
  if (leftFare.index != null && rightFare.index != null && leftFare.index === rightFare.index) {
    return true
  }
  return leftFare.id != null && rightFare.id != null && leftFare.id === rightFare.id
}

// Combo VN = nhiều chặng chung một fare (không phụ thuộc số chiều tìm kiếm,
// nên chuyến quốc nội 2 fare riêng không bị ảnh hưởng).
export const isVnComboEntry = (
  entries: FareEntry[],
  index: number,
) => {
  const entry = entries[index]
  if (entry?.flight?.fareData?.system !== "VN") return false
  return entries.filter((candidate) => sameVnFare(entry, candidate)).length > 1
}

// Giá combo VN nằm trên leg 0; các leg sau cùng fare không được cộng thêm (giống Galileo).
export const isDuplicateVnComboLeg = (
  entries: FareEntry[],
  index: number,
) => {
  const entry = entries[index]
  if (entry?.flight?.fareData?.system !== "VN") return false
  return entries.slice(0, index).some((candidate) => sameVnFare(entry, candidate))
}
